import { useNavigate } from 'react-router-dom';
import { formatDistance} from 'date-fns'
import { MdFilePresent } from 'react-icons/md';
import { VscCallOutgoing } from 'react-icons/vsc';
import { useSelector } from 'react-redux';

const PrevChanneLItemPreview = ({currentUser,item,onClick,practiceName}) => {
  const user = useSelector((state) => state.auth)
  const token = user.userInfo.doctor_login.sendbird_user_id
  const nickname = item?.members
    ?.filter((item) => item?.userId !== token)
    .map((item) => item.nickname)
    .join(', ')

  const navigate=useNavigate();
  const gotToChatSpace=()=>{
      onClick && onClick(item);
  }
  const getName=()=>{
    const user=item.members.filter(x=>x.userId!==currentUser?.userInfo?.doctor_login?.sendbird_user_id);
    if(item.name==="Admin")
    {
      return "ConnectCare Team"
    }
    else if(item.name==="Teams")
    {
     
      const filtered=item.members.filter((x)=>x.userId!==currentUser?.userId);
      
        return filtered?.map((item,index)=>filtered.length-1===index?item.nickname:item.nickname+",");
    }
    else if(item.name==="DPCDoctor")
    { 
      const filtered=item.members.filter((x)=>x.userId.slice(0,2)==="PA");
      return filtered?.map((item,index)=>filtered.length-1===index?item.nickname:item.nickname+",");
    }
  }
  return (
    <div className='w-full min-h-[50px]' onClick={gotToChatSpace}>
      <button className="w-full text-left py-2 focus:outline-none focus-visible:bg-indigo-50 border-b p-2">
        <div className="flex items-center">
          <section className='items-start flex-shrink-0 mr-3 h-[40px] w-[40px] rounded-full border-2'>
            <img className="w-full h-full object-cover object-center rounded-full" src={item.coverUrl ? item.coverUrl : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-HmAlYRaMiTx6PqSGcL9ifkAFxWHVPvhiHQ&usqp=CAU"} alt="Marie Zulfikar" />
          </section>
          <p className='p-4 pl-2 font-semibold'>{nickname}</p>
        </div>
        <div className="flex items-center">
          <div className='flex gap-4'>
            {(item?.lastMessage?.messageType !== "file" && item?.lastMessage?.customType != "VIDEO_CALL") && <p className="text-sm">{((item?.lastMessage?.message)?.length > 100) ? `${(item?.lastMessage?.message)?.slice(0, 100) + '   ........'}` : item?.lastMessage?.message} </p>}
            {item?.lastMessage?.messageType == "file" && <p className="flex text-sm  text-gray-900 "><MdFilePresent className='m-1' />{item?.lastMessage?.name} </p>}
            {item?.lastMessage?.customType == "VIDEO_CALL" &&
              <p className="flex text-sm text-everglade-900 "><VscCallOutgoing className='m-1' />Call</p>}
            <p className="text-sm text-gray-500 truncate dark:text-gray-400">
              {item?.lastMessage?.createdAt && formatDistance(new Date(item?.lastMessage?.createdAt), new Date(), { addSuffix: true })}
            </p>
          </div>
        </div>
      </button>
    </div>
  );
}
export default PrevChanneLItemPreview;